import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiX } = FiIcons;

const QualificationSection = () => {
  return (
    <section className="qualification-section py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            This Program Is <span className="text-red-600">NOT</span> for Everyone
          </h2>
          <p className="text-xl text-gray-600">Who This Is For (and Not For)</p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <motion.div 
            className="perfect-for bg-green-50 p-8 rounded-2xl border-2 border-green-200"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-green-800 mb-6 flex items-center">
              <SafeIcon icon={FiCheck} className="mr-3 text-3xl" />
              Perfect For
            </h3>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiCheck} className="text-green-600 mt-1 flex-shrink-0" />
                <span>Action-takers who want recurring income, not just one-time projects</span>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiCheck} className="text-green-600 mt-1 flex-shrink-0" />
                <span>Coaches, trainers, agency owners, and business owners who can invest at least ₹7,500/month to run their software company</span>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiCheck} className="text-green-600 mt-1 flex-shrink-0" />
                <span>People willing to follow step-by-step guidance and implement daily for 7 days</span>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiCheck} className="text-green-600 mt-1 flex-shrink-0" />
                <span>Serious entrepreneurs ready to build long-term wealth through recurring revenue</span>
              </li>
            </ul>
          </motion.div>

          <motion.div 
            className="not-for bg-red-50 p-8 rounded-2xl border-2 border-red-200"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-red-800 mb-6 flex items-center">
              <SafeIcon icon={FiX} className="mr-3 text-3xl" />
              Not For
            </h3>
            <ul className="space-y-4 text-gray-700">
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiX} className="text-red-600 mt-1 flex-shrink-0" />
                <span>People who want "get rich quick without doing anything"</span>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiX} className="text-red-600 mt-1 flex-shrink-0" />
                <span>Those who are not ready to invest in tools or implementation</span>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiX} className="text-red-600 mt-1 flex-shrink-0" />
                <span>Excuse-makers who never complete action items</span>
              </li>
              <li className="flex items-start space-x-3">
                <SafeIcon icon={FiX} className="text-red-600 mt-1 flex-shrink-0" />
                <span>People looking for theoretical knowledge without implementation</span>
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <p className="text-xl text-gray-700 mb-8 font-semibold">
            If you're a serious action-taker, keep reading. If not, this page is not for you.
          </p>
          
          <motion.a
            href="https://abdul.cc/earnwithabdul"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-blue-600 to-blue-800 text-white font-bold text-lg px-10 py-4 rounded-full hover:from-blue-700 hover:to-blue-900 transition-all duration-300 transform hover:scale-105 shadow-lg"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Yes, I'm Serious – Show Me the Plan
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default QualificationSection;